var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "px-20 px-sm-30"
  }, [_c('div', {
    staticClass: "new-container mx-auto"
  }, [_vm.mySims ? [_vm.emptyType === 'referral' && _vm.mySims.length ? _c('div', {
    staticClass: "new-container mx-auto mt-20 display-lg-none"
  }, [_c('ReferralBanner')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sim-list d-grid gap-30 store-grid-cols-1 store-grid-cols-sm-2 store-grid-cols-md-3 py-30 py-sm-40"
  }, [_vm._l(_vm.mySims, function (eSim, index) {
    return _c('div', {
      key: `my-esim-item-${index}`
    }, [_c('sim', {
      attrs: {
        "type": "my-esims",
        "item": eSim,
        "list-type": eSim.operator.type === 'local' ? 'local-packages' : 'global',
        "country": eSim.operator.country,
        "from": "my-esims",
        "is-loading": eSim.dataUsageLoader,
        "usage-data": eSim.dataUsage,
        "show-renewals": _vm.showRenewals
      },
      on: {
        "onOpenSupportedCountries": _vm.onOpenSupportedCountries
      }
    })], 1);
  }), _vm._v(" "), _c('client-only', [_c('supported-countries-modal', {
    attrs: {
      "modal-view": _vm.modals.supportedCountries.model,
      "countries": _vm.modals.supportedCountries.countries,
      "title": _vm.$t('components.supported.countries.modal.available-countries-title'),
      "search-input-placeholder": _vm.$t('placeholder.supported.countries.modal.available-countries-search'),
      "empty-text": _vm.$t('global.no-country-available')
    },
    on: {
      "onCloseSupportedCountriesModal": _vm.onCloseSupportedCountries
    }
  })], 1)], 2), _vm._v(" "), !_vm.emptyViewWait ? _c('div', {
    staticClass: "w-100"
  }, [_c('buy-new-esim')], 1) : _vm._e()] : [!_vm.emptyViewWait ? [_c('empty-view', {
    attrs: {
      "type": _vm.emptyType,
      "page": "current"
    }
  })] : [_c('div', {
    staticStyle: {
      "min-height": "50vh"
    }
  }, [_c('client-only', [_c('v-lottie', {
    attrs: {
      "position": "fixed"
    }
  })], 1)], 1)]]], 2), _vm._v(" "), _c('KycVerifyModalWrapper'), _vm._v(" "), _c('KycDetailModal')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }